import React, { Component } from 'react';
import { Accordion, Modal, Button } from 'react-bootstrap';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';
import InfoUploadOne from '../assets/images/info-upload-1.jpg';
import InfoUploadTwo from '../assets/images/info-upload-2.jpg';
import InfoIcon from '../assets/images/info-icon.png';
import UploadIcon from '../assets/images/subir.png';
import FotoCarnet from '../assets/images/foto_carnet.png';
import { Tools } from '../utils/tools';
import FormFields from '../services/FormFields';
import { Global } from '../services/Global';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import ApiService from '../services/Api';
import { APIS } from '../services/Config';

let _fd = (localStorage.getItem('app_fd')) ? JSON.parse(Tools.decryptrData(localStorage.getItem('app_fd'))) : {};

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }
class DocumentationPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            program_selected: null,
            fields: (_fd.aditional_data !== null) ? _fd.aditional_data : FormFields.aditional_data,
            next_active: true,
            show_info: false,
            show_infoDoc: false,
            show_infoDocActive: '',
            documentos: [],
            status_btn: false,
            mapDocumentos: {
                DOC_FOTO: {
                    idDoc: 6, title: "Foto tamaño Carné", number: 1, required: true, showInfo: true, panelinfo: 'DOC_FOTO', file: [6]
                },
                DOC_DNI: {
                    idDoc: 4, title: "DNI, Carné de Extranjería ó Cédula de Identidad", number: 2, required: true, showInfo: true, panelinfo: 'DOC_DNI',
                    file: [4]
                },
                DOC_PAGO: {
                    idDoc: 2, title: "Comprobante de Pago de Inscripción", number: 3, required: true, showInfo: false, panelinfo: 'DOC_PAGO',
                    file: [2]
                },
                DOC_SUNEDU: {
                    idDoc: 9, title: "Validación de Bachiller registrado en SUNEDU", number: 4, required: true, showInfo: true, panelinfo: 'DOC_SUNEDU',
                    subTitle : 'Descarga',
                    file: [9]
                },
                DOC_DJF: {
                    idDoc: 20, title: "Declaración de Condiciones de Financiamiento", number: 5, required: true, showInfo: true, panelinfo: 'DOC_DJF',
                    subTitle: 'Descarga',
                    file: [20]
                },
                DOC_BOLETA: {
                    idDoc: 999, title: "2 últimas Boletas de Pago", number: 6, required: true, showInfo: false, panelinfo: 'DOC_BOLETA',
                    file: [7, 22]
                },
                DOC_BOLETA_1: {
                    idDoc: 7, title: "2 últimas Boletas de Pago", number: 6, required: true, showInfo: false, panelinfo: 'DOC_BOLETA'
                },
                DOC_BOLETA_2: {
                    idDoc: 22, title: "2 últimas Boletas de Pago", number: 6, required: true, showInfo: false, panelinfo: 'DOC_BOLETA'
                },
                DOC_OTROS: {
                    idDoc: 11, title: "Otros Documentos", number: 7, required: false, showInfo: false, panelinfo: 'DOC_OTROS',
                    file: [11]
                }
            }
        }

    }

    componentDidMount() {
        let _root = this;
        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {
            _root.setState({
                program_selected: JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp')))
            });

            Tools.showPreloader();
            let _idSubmission = _root.props.pro.idSubmission;
            if (_root.props.glo.userfindsub !== null) {
                _idSubmission = _root.props.glo.userfindsub.idSubmission;
            }
            ApiService.getData(`${APIS.documentoByIdSubmission}${_idSubmission}`)
                .then(res => {
                    Tools.hidePreloader();
                    _root.setState({
                        documentos: res.data
                    });
                    this.buildDocuments(res.data);
                })
                .catch(err => {
                    Tools.hidePreloader();
                    console.log(err);
                });
        }
    }

    buildDocuments(docs) {
        let statusBtn = false;
        let _root = this;
        const status = {
            btn_carnet: (docs.some(e => e.idTipo === 6)),
            btn_documento_identidad: (docs.some(e => e.idTipo === 4)),
            btn_documento_pago_inscripcion: (docs.some(e => e.idTipo === 2)),
            btn_documento_bachillerato: (docs.some(e => e.idTipo === 9)),
            btn_documento_primera_boleta: (docs.some(e => e.idTipo === 7)),
            btn_documento_segunda_boleta: (docs.some(e => e.idTipo === 22)),
            btn_documento_otros: (docs.some(e => e.idTipo === 11)),
            btn_documento_recibo_servicios: (docs.some(e => e.idTipo === 20))
        }
        if (_root.props.pro.tipoPrograma === 'MAES' && _root.props.pro.pagoformaPago !== 1) {
            if (status.btn_carnet &&
                status.btn_documento_identidad &&
                status.btn_documento_pago_inscripcion &&
                status.btn_documento_bachillerato) {
                statusBtn = true
            }
        } else if (_root.props.pro.tipoPrograma === 'MAES' && _root.props.pro.pagoformaPago === 1) {
            if (status.btn_carnet &&
                status.btn_documento_identidad &&
                status.btn_documento_pago_inscripcion &&
                status.btn_documento_bachillerato &&
                status.btn_documento_recibo_servicios &&
                status.btn_documento_primera_boleta &&
                status.btn_documento_segunda_boleta
            ) {
                statusBtn = true
            }
        } else {
            if (status.btn_carnet && status.btn_documento_identidad && status.btn_documento_pago_inscripcion) {
                statusBtn = true
            }
        }
        this.setState({ status_btn: statusBtn });
    }


    /*JABURTO*/
    getTitleByDocument = (eDoc) => {
        let docs = this.state.documentos.filter(e => eDoc.file.includes(e.idTipo));
        return <>
            <div className="row pt-1 pb-2 pl-2 ml-2 justify-content-center align-items-center border border-light" style={{ paddingLeft: '0px' }} >
                <div className="col-sm-10 col-md-9" style={{ fontWeight: 'bold' }}>
                    <button type="button" className="btn btn-default btn-circle ">{eDoc.number}</button>
                    <span style={{ marginLeft: 10, fontSize:'14px' }}>{eDoc.title}</span>
                    {eDoc.required === true &&
                        <span style={{ marginLeft: 5, color: 'red' }}>*</span>}

                    {!eDoc.subTitle &&
                        eDoc.showInfo === true &&
                        <i style={{ marginLeft: 10 }} className="fa fa-question-circle" aria-hidden="true" onClick={(e) => this.showInfoDoc(e, eDoc)} />
                    }
                    {(eDoc.idDoc === 20) &&
                        <span style={{ fontSize: 12, marginLeft: 5, fontWeight: 300 }}>Descárgalo aquí
                            <i title="Descargar formato SUNEDU" onClick={this.onClickDownload} style={{ marginLeft: 10, color: '#049add', cursor:'pointer' }} className="fa fa-download"></i>
                        </span>
                    }
                    {(eDoc.idDoc === 9) &&
                        <span style={{ fontSize: 12, marginLeft: 5, fontWeight: 300 }}>Descárgalo aquí
                           <a style={{textDecoration:'none', marginLeft: 10, color: '#049add'}} target={"_blank"} without rel="noreferrer" href="https://www.sunedu.gob.pe/registro-nacional-de-grados-y-titulos/" className="fa fa-link"></a>
                        </span>
                    }
                </div>
                <div className="col-sm-10 col-md-3">
                    {(docs.length !== eDoc.file.length) ?
                        <Button className="btn btn-primary btn-style-9 position-relative">
                            Subir documento
                            <input
                                type="file"
                                name="file"
                                id='btn-file-photo-carnet'
                                className='btn-file-photo-carnet'
                                onChange={(event) => this.fnSaveDocument(event, eDoc)}
                            />
                            <img className="icon" alt="" src={UploadIcon} />
                        </Button> :
                        <div style={{ float: 'right' }}>
                            {/* <i class="fa fa-check-circle check-circle-verde-2" aria-hidden="true"></i> */}
                        </div>
                    }

                </div>
            </div>
            {docs.map((element) => {
                return <div className="row pt-1 pb-2 pl-2 ml-2 justify-content-center align-items-center border border-light" style={{ paddingLeft: '45px' }} >
                    <div className="col-sm-10 col-md-10">
                        <small className="pt-1 pb-2 pl-2 ml-2">Nombre del documento: </small>
                        <small className="pt-1 pb-2 pl-2 ml-2" style={{ textDecoration: 'underline' }}>{element && element.nombreArchivo}</small>
                        <i style={{ marginLeft: 10, cursor: 'pointer' }}
                            className="fa fa-close trash-file-delete-1 ml-2"
                            aria-hidden="true" onClick={() => this.deleteDocument(element)}>
                        </i>
                    </div>
                    <div className="col-sm-10 col-md-2">
                    </div>
                </div>
            })}
        </>
    }

    deleteDocument = (eDoc) => {
        let _root = this;
        Tools.showPreloader();
        ApiService.deleteData(`${APIS.documento}/${eDoc.id}`).then(res => {
            Tools.hidePreloader();
            _root.loadDocumentsSaved();
        }).catch(err => { Tools.hidePreloader(); });
    }
    showInfo = (e) => {
        e.preventDefault();
        let _root = this;

        _root.setState({
            show_info: true
        });
    }

    hideInfo = (e) => {
        let _root = this;
        _root.setState({
            show_info: false,
            show_infoDocActive: ''
        });
    }

    showInfoDoc = (e, eDoc) => {

        e.preventDefault();
        let _root = this;

        _root.setState({
            show_infoDoc: true,
            show_infoDocActive: eDoc.panelinfo
        });
    }

    hideInfoDoc = (e) => {
        let _root = this;
        _root.setState({
            show_infoDoc: false
        });
    }
    //Method for send document
    fnSaveDocument = (event, eDoc) => {
        let file = event.target.files[0];
        let idDoc = eDoc.idDoc;
        var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if (!allowedExtensions.exec(file.name)) {
            alert('Los formatos permitidos son jpg, jpeg o png.');
            return;
        }
        let _root = this;
        //Validacion previa de documentos
        if (idDoc === 999) {

            let status_btn_documento_primera_boleta = (this.state.documentos.some(e => e.idTipo === 7));
            let status_btn_documento_segunda_boleta = (this.state.documentos.some(e => e.idTipo === 22))

            if (!status_btn_documento_primera_boleta && !status_btn_documento_segunda_boleta) {
                idDoc = 7;
            } else if (status_btn_documento_primera_boleta && !status_btn_documento_segunda_boleta) {
                idDoc = 22;
            }
            else {
                idDoc = 7;
            }
        }
        Tools.showPreloader();
        var formdata = new FormData();
        var json_request = {
            "id": "",
            "idSubmission": _root.props.pro.idSubmission,
            "idTipo": idDoc,
            "nombreArchivo": "",
            "nombreArchivoS3": "",
            "estado": ""
        }
        formdata.append("file", file);
        formdata.append("request", JSON.stringify(json_request));
        ApiService.postDataFormData(`${APIS.documento}`, formdata)
            .then(res => {
                Tools.hidePreloader();
                _root.props.process(_root.props.pro);
                _root.props.general(_root.props.glo);
                _root.loadDocumentsSaved();
            })
            .catch(err => {
                Tools.hidePreloader();
                console.log(err);
            });
    }

    loadDocumentsSaved = () => {
        let _root = this;

        Tools.showPreloader();
        ApiService.getData(`${APIS.documentoByIdSubmission}${_root.props.pro.idSubmission}`)
            .then(res => {
                Tools.hidePreloader();
                _root.setState({ documentos: res.data });
                this.buildDocuments(res.data);

            })
            .catch(err => {
                Tools.hidePreloader();
            });
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;
        Tools.showPreloader();
        _root.props.pro.isFinalSubmission = true;
        _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/documentacion'));
        _root.props.process(_root.props.pro);
        _root.props.general(_root.props.glo);

        if (!(_root.props.pro.idSubmissionType === 3 || _root.props.pro.idSubmissionType === 4)) {
            Tools.hidePreloader();

            ApiService.postData(`${APIS.submission}`, _root.props.pro)
                .then(res => {
                    Tools.hidePreloader();
                    _root.props.navigate('/inscripcion_finalizada');
                })
                .catch(err => {
                    Tools.hidePreloader();
                    console.log(err);
                });
        }
        else {
            Tools.hidePreloader();
            _root.props.navigate('/inscripcion_finalizada');
        }
    }

    onClickDownload = (e) => {
        e.preventDefault();
        let _root = this;

        ApiService.getDataFile(`${APIS.ddjjGenera}${_root.props.pro.idSubmission}`)
            .then((rescp) => {
                Tools.hidePreloader();
                let blob = new Blob([rescp.data], { type: 'application/pdf' });
                let objectUrl = window.URL.createObjectURL(blob);

                let link = document.createElement('a');
                link.href = objectUrl;
                link.download = `Condiciones-de-Financiamiento-de-Estudios.pdf`;

                link.dispatchEvent(
                    new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    })
                );
                setTimeout(() => {
                    window.URL.revokeObjectURL(objectUrl);
                    link.remove();
                }, 100);
            })
            .catch((err) => {
                Tools.hidePreloader();
            });
    }

    render() {
        const {
            program_selected,
            show_info,
            show_infoDoc,
            show_infoDocActive,
            mapDocumentos,
            status_btn,
        } = this.state;

        const {
            pro,
            navigate
        } = this.props;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                            {(program_selected !== null) ? <DashboardMenuComponent navigate={navigate} step={'4'} form={program_selected.form} /> : <></>}
                        </div>
                        <div className="col-md-9 right-side-dashboard">
                            <TopProcessComponent porcent="80" />
                            <div className="row content-dashboard">
                                <div className="col-sm-12">
                                    <div className="row pt-3 pb-3">
                                        <div className="col-sm-12 col-md-6"><TopComponent direction="back" label="Paso Previo" path="/forma-pago" /></div>
                                        <div className="col-sm-12 col-md-6"></div>
                                    </div>
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12">
                                            <h5><strong>Documentos indispensables para tu inscripción que estarán sujetos a aprobación</strong></h5>
                                        </div>
                                        <div className="col-sm-12 mt-3">
                                            <h6><strong>Conoce las mejores opciones para subir tus documentos</strong> <img className="info_btn" alt='' src={InfoIcon} onClick={this.showInfo} /></h6>
                                        </div>
                                    </div>
                                    <div className='cls-doc-header'>
                                        {this.getTitleByDocument(mapDocumentos.DOC_FOTO)}
                                        {this.getTitleByDocument(mapDocumentos.DOC_DNI)}
                                        {this.getTitleByDocument(mapDocumentos.DOC_PAGO)}
                                        {(pro.tipoPrograma === 'MAES') &&
                                            <React.Fragment>
                                                {this.getTitleByDocument(mapDocumentos.DOC_SUNEDU)}
                                                {(pro.pagoformaPago === 1) &&
                                                    <React.Fragment>
                                                        {this.getTitleByDocument(mapDocumentos.DOC_DJF)}
                                                        {this.getTitleByDocument(mapDocumentos.DOC_BOLETA)}
                                                    </React.Fragment>
                                                }
                                                {this.getTitleByDocument(mapDocumentos.DOC_OTROS)}
                                            </React.Fragment>
                                        }
                                    </div>
                                </div>
                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-8"></div>
                                    <div className="col-sm-12 col-md-4" style={{ textAlign: 'right' }}>
                                        <button
                                            className={(status_btn) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4 disable'}
                                            onClick={this.onClickNext}>
                                            Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <Modal size="lg" show={show_info} onHide={this.hideInfo} >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <h4 className="text-center"><strong>Aprende la mejor forma de<br />subir tus documentos</strong></h4>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <p><small><strong>Tus documentos son esenciales para tu proceso de admisión, por lo cual queremos recibirlos de la mejor manera. Para ayudarte te damos algunas opciones para completar este paso:</strong></small></p>
                                </div>
                            </div>
                            <div className="row">
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className="btn-auto"><span className="num_header letter">A</span> Utiliza el escáner de aplicación Google Drive</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="col-sm-12">
                                                <img src={InfoUploadOne} alt="" width="100%" />
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header className="btn-auto"><span className="num_header letter">B</span> Utiliza Microsoft Office Lens</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="col-sm-12">
                                                <img src={InfoUploadTwo} alt="" width="100%" />
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal >
                <Modal size="lg" show={show_infoDoc} onHide={this.hideInfoDoc}>
                    <Modal.Header closeButton>
                        Información adicional
                    </Modal.Header>
                    <Modal.Body>
                        {{
                            'DOC_FOTO':
                                <div className="row pt-1 pb-2 justify-content-center align-items-center border border-light" >
                                    <div className="col-sm-10 col-md-8">
                                        <p>
                                            Fotografía actual a color, con fondo blanco, vestimenta casual, usar una buena iluminación para evitar sombras.<br />
                                            (Tomada de frente sin sonreír, sin gorras ni lentes, formato JPG ó PNG).<br />
                                            La foto debe ser lo más nítida y clara posible.</p>
                                    </div>
                                    <div className="col-sm-10 col-md-4">
                                        <div className="col-sm-10 col-md-8">
                                            <h6><strong>Aquí te dejamos una guía para una mejor foto:</strong></h6>
                                            <p>
                                                <img className="icon" alt="" width="160px" src={FotoCarnet} ></img>
                                            </p>

                                        </div>
                                    </div>
                                </div>,
                            'DOC_DNI':
                                <div>
                                    <p className='text-bachiller-indication'>Frente y reverso </p>
                                    <p className='text-bachiller-indication'>Foto o PDF </p>
                                </div>,
                            'DOC_SUNEDU': <div>
                                <div className="col-sm-12 col-md-7 ">
                                    <p className='text-bachiller-indication'>Sube una foto de pantalla o el PDF de la verificación de tu Bachiller.<br />Descárgalo a través de este enlace: </p>
                                </div>
                                <div className='caja-link-sunedu-bachiller '>
                                    <a target={"_blank"} without rel="noreferrer" href="https://www.sunedu.gob.pe/registro-nacional-de-grados-y-titulos/">https://www.sunedu.gob.pe/registro-nacional-de-grados-y-titulos/</a>
                                </div>
                            </div>,
                            'DOC_BOLETA':
                                <div>
                                    <p className='text-bachiller-indication'>Foto o PDF </p>
                                </div>,
                            'DOC_PAGO': <div>
                                <p className='text-bachiller-indication'>Foto o PDF </p>
                            </div>,
                            'DOC_DJF': <div>
                                <div className="col-sm-12 col-md-12">
                                    <div className="col-sm-12 col-md-12">
                                        <p className='text-bachiller-indication'>Descargar declaración de condiciones de financiamiento.<br />Descárgalo a través de este enlace: </p>
                                    </div>
                                    <button type="button" className="btn btn-primary btn-sm btn-style-4" style={{ marginRight: '10px' }} onClick={this.onClickDownload}>Descargar declaración de condiciones de financiamiento</button>
                                </div>
                            </div>

                        }[show_infoDocActive]}
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentationPage);
